import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { toEuros } from 'lib/numbers';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';

interface Props {
  label: string;
  unitPrice?: number;
  price?: number;
  value?: string | number;
  quantity?: number;
  strong?: boolean;
  className?: string;
  isOption?: boolean;
}

const useStyles = createUseStyles((theme: Theme) => ({
  priceLine: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
  price: {
    textAlign: 'right',
  },
  strongLine: {
    ...theme.fonts.label,
    color: theme.colors.inkPrimary,
  },
  quantity: {},
}));

export const ProductLine = ({
  label,
  unitPrice,
  value,
  quantity = 1,
  strong,
  price,
  isOption,
  className,
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { t } = useTranslation();

  let finalValue = value;
  if (finalValue === undefined && unitPrice !== undefined) {
    finalValue = toEuros(unitPrice * quantity, true);
  }
  if (finalValue === undefined && price !== undefined) {
    finalValue = toEuros(price, true);
  }
  if (finalValue === undefined) {
    finalValue = '-';
  }

  return (
    <tr
      className={classnames(
        classes.priceLine,
        {
          [classes.strongLine]: strong,
        },
        className,
      )}
    >
      <td>
        {isOption ? '+ ' : ''}
        {label}
      </td>
      <td className={classes.quantity}>{quantity > 1 && `x${quantity}`}</td>
      <td className={classes.price}>{finalValue}</td>
    </tr>
  );
};
